import { BASE_BACKEND_URL, fetchWithAuth } from '../../../auth'
import { useEffect, useRef, useState } from 'react'

import { STORE_RELATIONS_SHOW_DEFAULT_DATA } from '../show/constants/storeShowConstants'

const useFetchStoreShow = (storeRelationId) => {
  const abortControllerRef = useRef(null)

  const [data, setData] = useState(STORE_RELATIONS_SHOW_DEFAULT_DATA)
  const [loading, setLoading] = useState(Boolean(storeRelationId))
  const [error, setError] = useState(null)

  const fetchStoreShow = async () => {
    abortControllerRef.current?.abort()

    const controller = new AbortController()
    abortControllerRef.current = controller

    try {
      setLoading(true)
      setError(null)

      const response = await fetchWithAuth(
        `${BASE_BACKEND_URL}/poc/store_relations_overview/${storeRelationId}`,
        {
          signal: controller.signal
        }
      )

      setData(response ?? STORE_RELATIONS_SHOW_DEFAULT_DATA)
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('fetchStoreShow error', err)
        setError(err)
      }
    } finally {
      setLoading(false)
      abortControllerRef.current = null
    }
  }

  useEffect(() => {
    if (!storeRelationId) {
      setLoading(false)
      return
    }

    fetchStoreShow()

    return () => {
      abortControllerRef.current?.abort()
    }
  }, [storeRelationId])

  return {
    data,
    loading,
    error,
    refetch: fetchStoreShow
  }
}

export default useFetchStoreShow
